import { Score } from './score.interface';

export interface CompanyRanking {
  _id: string;
  names: string;
  surnames: string;
  picture_profile?: string;
  score: Score;
  status: CompanyStatus;
  country: string;
  country_iso: string;
}

export enum CompanyStatus {
  Active = 'active',
  Abandonment = 'abandonment',
  PreRegistered = 'pre_registered',
  Registered = 'registered',
  Finalized = 'finalized',
  Tribe = 'tribe',
}
